import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_BEGIN,
  REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_SUCCESS,
  REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_FAILURE,
  REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_DISMISS_ERROR,
} from './constants';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
export function exportOosReportByCategory(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/orderDetail/exportOosReportByCategory`, args);
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportOosReportByCategoryError() {
  return {
    type: REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_DISMISS_ERROR,
  };
}

export function useExportOosReportByCategory() {
  const dispatch = useDispatch();

  const { exportOosReportByCategoryPending, exportOosReportByCategoryError } = useSelector(
    state => ({
      exportOosReportByCategoryPending: state.reports.exportOosReportByCategoryPending,
      exportOosReportByCategoryError: state.reports.exportOosReportByCategoryError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportOosReportByCategory(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportOosReportByCategoryError());
  }, [dispatch]);

  return {
    exportOosReportByCategory: boundAction,
    exportOosReportByCategoryPending,
    exportOosReportByCategoryError,
    dismissExportOosReportByCategoryError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportOosReportByCategoryPending: true,
        exportOosReportByCategoryError: null,
      };

    case REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_SUCCESS:
      // The request is success
      return {
        ...state,
        exportOosReportByCategoryPending: false,
        exportOosReportByCategoryError: null,
      };

    case REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_FAILURE:
      // The request is failed
      return {
        ...state,
        exportOosReportByCategoryPending: false,
        exportOosReportByCategoryError: action.data.error,
      };

    case REPORTS_EXPORT_OOS_REPORT_BY_CATEGORY_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportOosReportByCategoryError: null,
      };

    default:
      return state;
  }
}
